import {Avatar, Input, Upload} from "antd";
import {useState} from "react";

const AccountInfo = ({}) => {
    const [avatar, setAvatar] = useState(false);
    const [img, setImg] = useState(null);

    return (
        <div className={"p-4"}>
            <h2 className={"font-semibold text-2xl mb-4"}>Thông tin tài khoản</h2>
            <div className={"flex flex-wrap gap-4 items-center"}>
                <div className={"w-full md:w-auto"}>
                    {avatar ? (
                        <Avatar alt={"Avatar"} src={img} className={"size-24"}/>
                    ) : (
                        <Upload showUploadList={false}
                                accept={"image/*"}
                                className={"cursor-pointer"}>
                            <Avatar alt={"Avatar"} src={img} className={"size-24"}/>
                        </Upload>
                    )}
                </div>
                <div className={"grid grid-cols-1 w-full md:w-1/2 gap-2"}>
                    <div>
                        <label className={"font-semibold"}>Họ và tên</label>
                        <Input placeholder={"Họ và tên"}/>
                    </div>
                    <div>
                        <label className={"font-semibold"}>Mô tả</label>
                        <Input.TextArea rootClassName={"max-h-24"} placeholder={"Mô tả"}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountInfo;